export const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN || "auth.configura.dev";
export const AUTH0_CLIENT_ID =
	process.env.REACT_APP_AUTH0_CLIENT_ID || "G4aouYT7jMzmGjT0QN0kdCaNd4Z9alI0";
export const CATADMIN_URL =
	process.env.REACT_APP_CATADMIN_URL || "https://admin.api.stage.configura.com";
